export const inlineStyles = {
    thresholdArea: {
        fill: 'rgb(104, 210, 223)',
        fillOpacity: 0.1,
    },
};
